import axios from "axios";
import Auth from "../../lib/middleware/auth";
import API_MAP from "../../services/uri";

// useSelector / types

export const uploadStoryCover = async (credentials, id) => {
	const response = await axios.post(
		`${API_MAP.WeddingStoryCover}?weddingId=${id}`,
		credentials
	);
	return response;
};

export const uploadWeddingPhotos = async (credentials) => {
	const token = Auth.getToken();
	const { formData, weddingData } = credentials;
	const { weddingId, albumId } = weddingData;
	const config = {
		headers: { "content-type": "multipart/form-data" },
		Authorization: `Bearer ${token}`,
	};

	console.log(weddingId);
	const response = await axios.post(
		`${API_MAP.UploadWeddingPhotos}?albumId=${albumId}&weddingId=${weddingId}`,
		formData,
		config
	);
	return response;
};

export const uploadWeddingGift = async (credentials) => {
	const token = Auth.getToken();
	const { formData, weddingData } = credentials;
	const { weddingId } = weddingData;
	const config = {
		headers: { "content-type": "multipart/form-data" },
		Authorization: `Bearer ${token}`,
	};
	const response = await axios.post(
		`${API_MAP.uploadWeddingGift}?weddingId=${weddingId}`,
		formData,
		config
	);
	return response;
};

export const uploadKycSelfie = async ({ formData, config }) => {
	const response = await axios.post(
		`${API_MAP.UploadKycSelfie}`,
		formData,
		config
	);
	return response.data;
};

export const uploadKycDocument = async ({ formData, config }) => {
	const response = await axios.post(
		`${API_MAP.UploadKycSelfie}`,
		formData,
		config
	);
	return response.data;
};

export const uploadVendorCoverPhoto = async ({
	formData,
	config,
	credentials,
}) => {
	const response = await axios.post(
		`${API_MAP.vendorCoverImage}?vendorId=${credentials}`,
		formData,
		config
	);
	return response.data;
};

export const uploadVendorPortfolioImages = async ({
	formData,
	config,
	credentials,
}) => {
	const response = await axios.post(
		`${API_MAP.vendorPortfolioImage}?vendorId=${credentials}`,
		formData,
		config
	);
	return response.data;
};

export const UploadWeddingPostImages = async ({
	formData,
	config,
	credentials,
}) => {
	const response = await axios.post(
		`${API_MAP.UploadWeddingPostImages}?weddingId=${credentials}`,
		formData,
		config
	);
	return response.data;
};
